import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { defer, forkJoin, Observable, ReplaySubject, Subject } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';
import { environment } from 'environments/environment';

@Injectable({
    providedIn: "root",
})
export class ApiService {
    public dataLoaderObservable = new Subject<boolean>();

    private context = "";

    constructor(
        private httpClient: HttpClient
    ) {
        this.context = environment.context;
    }

    sendGETRequestObs(url: string): Pending<any> {
        const status = new ReplaySubject<Status>();
        const request = this.httpClient.get<any>(this.context + url).pipe(
            catchError((error) => {
                status.next(Status.ERROR);
                throw error;
            }),
            tap(() => status.next(Status.SUCCESS))
        );
        const data = defer(() => {
            status.next(Status.LOADING);
            return request;
        });
        return { data, status };
    }

    sendPOSTRequestObs(url: string, json: any): Pending<any> {
        const status = new ReplaySubject<Status>();
        const request = this.httpClient.post<any>(this.context + url, json).pipe(
            catchError((error) => {
                status.next(Status.ERROR);
                throw error;
            }),
            tap(() => status.next(Status.SUCCESS))
        );
        const data = defer(() => {
            status.next(Status.LOADING);
            return request;
        });
        return { data, status };
    }

    sendGETRequest(url: string, params: any = {}): Observable<any> {
        return this.httpClient.get(this.context + url, { params });
    }

    sendMAPRequest(url: string) {
        const headers = new HttpHeaders();
        headers.append("Access-Control-Allow-Headers", "Content-Type");
        headers.append("Access-Control-Allow-Methods", "GET");
        headers.append("Access-Control-Allow-Origin", "*");
        const proxyurl = "https://cors-anywhere.herokuapp.com/";
        return this.httpClient.get(url, { headers: headers });
    }

    sendPOSTRequest(url: string, data: any, options: { params?: any } = {}): Observable<any> {
        return this.httpClient.post(this.context + url, data, options);
    }

    sendPUTRequest(url: string, data: any, options: { params?: any } = {}): Observable<any> {
        return this.httpClient.put(this.context + url, data, options);
    }

    sendDELETERequest(url: string, options: { params?: any } = {}): Observable<any> {
        return this.httpClient.delete(this.context + url, options);
    }

    uploadFile(url: string, fileToUpload: any, metadata: any = null): Observable<any> {
        const formData: FormData = new FormData();
        formData.append('file', fileToUpload, fileToUpload.name);
        if (metadata != null) {
            formData.append('metadata', JSON.stringify(metadata));
        }
        return this.httpClient
            .post(this.context + url, formData);
    }

    uploadFile1(url: string, formData: any, metadata: any = null): Observable<any> {
        return this.httpClient
            .post(this.context + url, formData, {
                reportProgress: true,
                observe: 'events'
            });
    }

    sendNotificationRequest(url: string, data: any) {
        return this.httpClient.post(url, data);
    }

    public downloadFile(url: string): Observable<Blob> {
        return this.httpClient.get(this.context + url, {
            responseType: "blob",
        });
    }

    validateResponse(response: any): Boolean {
        let isValid = true;
        if (response && response[0] && response[0].errorMsg) {
            isValid = false;
        }
        return isValid;
    }

    response = [];

    searchPlaces(searchString: any) {
        if (typeof searchString === "string") {
            let googleSearchString = searchString.split(" ").join("%20");
            let payload: any = {};
            payload["username"] = "vivek";
            payload["url"] =
                "https://maps.googleapis.com/maps/api/place/findplacefromtext/json?input=" +
                googleSearchString +
                "&inputtype=textquery&fields=formatted_address,name,geometry&key=AIzaSyCQP6QMvulWo9K5onllu4DDqqwlkwdnhe0";
            payload["requestType"] = "GET";

            const googleRequest = this.sendPOSTRequest(
                "/rest/unauthorize/callHandler",
                payload
            );
            const fueledRequest = this.sendGETRequest(
                "/rest/CustomerAddress/search?_s=id=ge=0;isDeleted==false;addressLine1==" +
                searchString +
                "&orderBy=id&orderType=asc&ulimit=10000&llimit=0"
            );
            const requestArray = [];
            requestArray.push(googleRequest);
            requestArray.push(fueledRequest);
            return forkJoin(requestArray);
        } else {
            const obsUsingCreate = Observable.create((observer: any) => {
                observer.next([], [searchString]);
                observer.complete();
            });
            return obsUsingCreate;
        }
    }
}


export interface Pending<T> {
    data: Observable<T>;
    status: Observable<Status>;
}

export enum Status {
    LOADING = "LOADING",
    SUCCESS = "SUCCESS",
    ERROR = "ERROR",
}
